module.exports = __webpack_public_path__ + "static/img/son3_active.15a0b1cc.png";